<template>
  <component
    :is="tag"
    v-on="$listeners"
  >
    <b-avatar
      size="42"
      :src="user.profile.image"
      :badge="isChatContact"
      class="badge-minimal"
      :badge-variant="resolveAvatarBadgeVariant(user.profile.onlineStatus)"
      variant="transparent"
    />
    <div class="chat-info flex-grow-1">
      <h5 class="mb-0">
        {{ user.userName || $t('Anonymous') }}
        <img v-if="user.isAssistant" :src="verifiedIcon" width="16" style="border: none; margin: -4px 0 0 4px; " />
      </h5>
      <p class="card-text text-truncate">
        <template v-if="isChatContact">
          <template v-if="user.lastMessage.type === 'CHAT_CALL' && !user.lastMessage.message">
            <feather-icon icon="PhoneIcon" size="12" style="margin-right: 3px;" />
          </template>
          <template v-else>{{ user.lastMessage.message }}</template>
        </template>
      </p>
    </div>
    <div
      v-if="isChatContact"
      class="chat-meta text-nowrap"
    >
      <small class="float-right mb-25 chat-time">
        {{ formatDateToMonthShort(user.lastMessage.dateSent, { hour: 'numeric', minute: 'numeric' }) }}
      </small>
      <b-badge
        v-if="user.unSeenMsgCount"
        pill
        variant="primary"
        class="float-right"
      >
        {{ user.unSeenMsgCount }}
      </b-badge>
      <b-badge
        v-if="user.pendingMediaRequest"
        pill
        variant="danger"
        class="float-right mr-50 media-request-badge"
      >
        <feather-icon
          :icon="pendingMediaRequestIcon"
          size="11"
        />
        {{ $t('New Request') }}
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from 'bootstrap-vue'
import { formatDateToMonthShort } from '@core/utils/filter'
import useChat from './useChat'

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    user: {
      type: Object,
      required: true,
    },
    isChatContact: {
      type: Boolean,
      dedfault: false,
    },
  },
  data() {
    return {
      verifiedIcon: require('@/assets/images/icons/verified.png'),
    }
  },
  computed: {
    pendingMediaRequestIcon() {
      const mediaType = this.user.pendingMediaRequest?.mediaType
        || this.user.pendingMediaRequest?.media_type
      return mediaType === 'video' ? 'VideoIcon' : 'CameraIcon'
    },
  },
  setup() {
    const { resolveAvatarBadgeVariant } = useChat()
    return { formatDateToMonthShort, resolveAvatarBadgeVariant }
  },
}
</script>

<style lang="scss" scoped>
// Saat üstte, okunmamış / yeni istek rozetleri altında; önceden ikisi de float olduğu için saat kısa
// olunca ("13:47") rozet saatin soluna, uzun olunca alt satıra düşüyordu
.chat-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  > * {
    float: none !important;
  }

  .media-request-badge {
    margin-right: 0 !important;
  }
}

.media-request-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.68rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
}
</style>
